import styled from 'styled-components';
import _Alert from '@mui/material/Alert';

export const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 59.19px);
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;

  @media (max-width: 768px) {
    overflow-y: scroll;
  }
`;

export const Header = styled.div`
  background-color: #2274a5;
  padding: 12px 0 16px 0;
  text-align: center;
  flex-shrink: 0;

  h1 {
    font-family: Roboto;
    color: white;
    font-size: 1.5rem;
    font-weight: 400;
    margin: 0;
  }

  @media (max-width: 768px) {
    padding: 16px 0;

    h1 {
      font-size: 20px;
      padding: 0 16px;
    }
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex: 1;
  background-color: white;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    overflow: auto;
  }
`;

export const FormSection = styled.div`
  flex: 1;
  padding: 40px;
  width: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 36px 24px;
    width: 100%;
    overflow: auto;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 50px 5vw;

  @media (max-width: 1820px) {
    padding: 50px 3vw;
  }

  @media (max-width: 1420px) {
    padding: 50px 1vw;
  }

  @media (max-width: 1020px) {
    padding: 50px 0px;
  }

  @media (max-width: 768px) {
    padding: 0px;
    padding-bottom: 24px;
  }
`;

export const FormTitle = styled.h2`
  font-family: Roboto;
  font-weight: 700;
  font-size: 24px;
  line-height: 36.5px;
  color: #333;
  margin: 0 0 30px 0;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 24px;
  }
`;

export const FormSectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 30px;

  svg {
    color: #666;
    font-size: 20px;
  }

  h3 {
    font-family: Roboto;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #333;
    margin: 0;
  }

  @media (max-width: 768px) {
    margin-bottom: 24px;

    h3 {
      font-size: 16px;
    }
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border: 1px solid #d2d4d7;
  border-radius: 8px;
  font-size: 16px;
  color: #333;
  background-color: white;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  font-family: Roboto;

  &:focus {
    outline: none;
    border-color: #1976d2;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #999;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #999;
  }

  @media (max-width: 768px) {
    font-size: 16px; /* Prevent zoom on iOS */
  }
`;

export const PhoneInput = styled.div`
  width: 100%;
  height: 50px;
  border: 1px solid #d2d4d7;
  border-radius: 8px;
  background-color: white;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  font-family: Roboto;

  &:focus-within {
    border-color: #1976d2;
  }

  input {
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    font-size: 16px;
    color: #333;
    background: transparent;

    &::placeholder {
      color: #999;
    }
  }

  @media (max-width: 768px) {
    input {
      font-size: 16px; /* Prevent zoom on iOS */
    }
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border: 1px solid #d2d4d7;
  border-radius: 8px;
  font-size: 16px;
  color: #333;
  background-color: white;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  font-family: Roboto;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
  padding-right: 48px;

  &:focus {
    outline: none;
    border-color: #1976d2;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #999;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    font-size: 16px; /* Prevent zoom on iOS */
  }
`;

export const SectionTitle = styled.h3`
  font-family: Roboto;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333;
  margin: 30px 0 20px 0;

  @media (max-width: 768px) {
    font-size: 16px;
    margin: 24px 0 16px 0;
  }
`;

export const Button = styled.button`
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 20px;
  width: 100%;
  margin-bottom: 36px;

  &:hover {
    background-color: #45a049;
  }

  &:active {
    background-color: #3d8b40;
  }

  @media (max-width: 768px) {
    padding: 14px 20px;
    font-size: 16px;
    margin-top: 16px;
  }
`;

export const ImageSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  padding: 40px;

  @media (max-width: 768px) {
    display: none;
  }

  img {
    max-width: 100%;
    height: auto;
    max-height: 500px;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  padding: 8px 20px;
`;

export const ImageContainer = styled.div`
  flex-shrink: 3;
  img {
    max-width: 600px;
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }
  @media (max-width: 882px) {
    display: none;
    opacity: 0;
  }
`;

export const Alert = styled(_Alert)`
  margin: 4px 2px;
`;

export const ContactFormHeaderScroll = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20px;
  padding: 20px;

  @media (min-width: 1024px) {
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    padding: 0px;
    overflow-y: none;
    gap: 16px;
    padding-right: 0;
    max-width: 100%;
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

// Estilos para verificação OTP - Pixel Perfect
export const VerificationContainer = styled.div`
  background: white;
  padding: 0;
  max-width: 100%;
  margin: 0;
`;

// Delivery method tiles
export const DeliveryOptions = styled.div`
  /* use grid to match the two-column layout used by the phone fields */
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px; /* same gap as FieldRow */
  align-items: center;
  margin-bottom: 8px;
  width: 100%;
  /* span both columns of the parent FieldRow so the tiles go edge-to-edge */
  grid-column: 1 / -1;
  justify-items: stretch;
`;

export const DeliveryOption = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  /* make the tile match the height of the phone/cell fields */
  height: 50px;
  /* increase left padding so the selection dot sits more toward the center */
  padding: 0 12px 0 18px;
  border-radius: 12px;
  border: 1px solid #e6e6e6;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.12s ease;
  user-select: none;
  /* make each tile fill its grid cell (matches phone inputs width) */
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;

  /* custom radio indicator on the left */
  &::before {
    content: '';
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #d9d9d9;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  margin-right: 4px;
    box-sizing: border-box;
    flex: 0 0 auto;
    background: transparent;
  }

  &.selected::before {
    /* green circle with inner white dot */
    background: radial-gradient(circle at center, #ffffff 0 38%, #1976d2 39% 100%) !important;
    border-color: #1976d2 !important;
  }

  img {
    width: 18px;
    height: 18px;
    display: block;
    margin-right: 0;
    flex: 0 0 auto;
    object-fit: contain;
  }

  .iconBadge {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 0; /* tighten spacing */
  background: #ffffff;
  border: 1px solid #e6e6e6;
  }

  /* for whatsapp, let the SVG provide its own green circle; show it cleanly */
  .iconBadge.whatsapp { background: transparent; border: none; padding: 0; }
  .iconBadge.call { background: #ffffff; border-color: #e6e6e6; }

  /* keep label on a single line (no wrap). if it overflows, show ellipsis */
  span {
    font-family: Rubik;
    font-size: 0.95rem;
    color: #171c24;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
    display: block;
    flex: 1 1 auto;
    margin: 0;
  }

  input[type='radio'] {
    display: none;
  }

  &:hover {
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }

  &.selected {
    border-color: #1976d2;
    background: #f3fff5;
    box-shadow: 0 6px 18px rgba(0, 168, 31, 0.08);
  }

  /* Remove default browser focus outline (blue) and keep our visual */
  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: 0 6px 18px rgba(0, 168, 31, 0.08);
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    gap: 10px;
    img { width: 24px; height: 24px; }
    span { font-size: 0.95rem; }
  }
`;

export const VerificationTitle = styled.h2`
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: 24px;
  leading-trim: NONE;
  line-height: 36.5px;
  letter-spacing: 0%;
  line-height: 1.4;

  margin: 0 0 37px 0;
`;

export const VerificationDescription = styled.p`
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0%;
`;

export const ChangeNumberLink = styled.button`
  background: none;
  border: none;
  color: #1976d2;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  margin: 0 0 24px 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  &:hover {
    color: #1565c0;
  }
`;

export const CodeInputContainer = styled.div`
  margin-bottom: 16px;
  position: relative;

  ${Label} {
    position: absolute;
    top: -8px;
    left: 12px;
    background: white;
    padding: 0 4px;
    font-size: 12px;
    color: #666;
    font-weight: 400;
    z-index: 1;
  }
`;

export const CodeInput = styled.input`
  width: 100%;
  padding: 16px 16px 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  text-align: left;
  letter-spacing: 0;
  font-weight: 400;
  transition: border-color 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: white;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #1976d2;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #999;
  }
`;

export const ResendContainer = styled.div`
  text-align: left;
  margin-bottom: 24px;
`;

export const ResendText = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const ResendButton = styled.button`
  background: none;
  border: none;
  color: #1976d2;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  &:hover:not(:disabled) {
    color: #1565c0;
  }

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
    text-decoration: none;
  }
`;

export const ErrorMessage = styled.div`
  background-color: #ffebee;
  color: #c62828;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
  border-left: 4px solid #c62828;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const SuccessMessage = styled.div`
  background-color: #e8f5e8;
  color: #2e7d32;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
  border-left: 4px solid #2e7d32;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const VerificationButton = styled.button`
  width: 100%;
  background-color: #1976d2;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  &:hover:not(:disabled) {
    background-color: #1565c0;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
